import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

declare global {
  interface Window {
    WOW: any;
  }
}

const MessageChairperson: React.FC = () => {
  useEffect(() => {
    // Initialize data-background attributes
    const elements = document.querySelectorAll('[data-background]');
    elements.forEach((element) => {
      const bg = element.getAttribute('data-background');
      if (bg) {
        (element as HTMLElement).style.backgroundImage = `url(${bg})`;
      }
    });

    // Initialize WOW.js for scroll animations
    if (window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }
  }, []);

  return (
    <>
      {/* Page banner area start here */}
      <section className="banner__inner-page bg-image pt-160 pb-160"
        data-background="/assets/images/banner/banner-inner-page.jpg">
        <div className="container">
          <h2 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">Message from Chairperson</h2>
          <div className="breadcrumb-list wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
            <Link to="/">Home</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i></span>
            <Link to="/about">About Us</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i>Message from Chairperson</span>
          </div>
        </div>
      </section>
      {/* Page banner area end here */}

      {/* Message area start here */}
      <section className="pt-120 pb-120">
        <div className="container">
          {/* Top Section with Image and Intro */}
          <div className="row g-4 mb-60">
            <div className="col-lg-5">
              <div className="wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                <img 
                  src="/assets/images/team/team-image1.jpg" 
                  alt="Rajan Khanal - Chairperson"
                  style={{ width: '100%', borderRadius: '10px', boxShadow: '0 5px 30px rgba(0, 0, 0, 0.1)' }}
                />
                <div style={{ 
                  marginTop: '30px', 
                  padding: '25px', 
                  backgroundColor: '#03A84A', 
                  borderRadius: '10px',
                  color: 'white',
                  textAlign: 'center'
                }}>
                  <h4 style={{ color: 'white', fontSize: '26px', fontWeight: '700', marginBottom: '10px' }}>
                    Rajan Khanal
                  </h4>
                  <p style={{ color: 'rgba(255, 255, 255, 0.95)', fontSize: '18px', fontWeight: '500' }}>
                    Chairperson & Founder
                  </p>
                  <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '16px', marginTop: '15px', marginBottom: 0 }}>
                    <i className="fa-solid fa-clock" style={{ marginRight: '8px' }}></i>
                    More than 10 years of dedicated service
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
                <div className="section-header mb-30">
                  <h5>
                    <i className="fa-regular fa-angles-left pe-1"></i> CHAIRPERSON'S MESSAGE <i className="fa-regular fa-angles-right ps-1"></i>
                  </h5>
                  <h2 style={{ color: '#0C2239', marginTop: '15px' }}>A Journey of Love, Hope, and Transformation</h2>
                </div>

                <div style={{ 
                  padding: '30px', 
                  backgroundColor: '#FFF5F2', 
                  borderRadius: '10px',
                  borderLeft: '5px solid #03A84A',
                  marginBottom: '30px'
                }}>
                  <p style={{ 
                    fontSize: '20px', 
                    lineHeight: '1.8', 
                    color: '#0C2239',
                    fontStyle: 'italic',
                    margin: 0
                  }}>
                    "When the children call me 'Daddy,' I feel truly blessed. In those precious moments, I realize that what we do at New Life Nepal is not just work—it's a calling, a divine gift that has enriched my life beyond measure."
                  </p>
                  <p style={{ 
                    fontSize: '16px', 
                    color: '#03A84A',
                    fontWeight: '600',
                    marginTop: '15px',
                    marginBottom: 0
                  }}>
                    — Rajan Khanal
                  </p>
                </div>

                <div style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.9' }}>
                  <p style={{ marginBottom: '20px' }}>
                    Dear Friends, Supporters, and Well-wishers,
                  </p>
                  
                  <p style={{ marginBottom: '0' }}>
                    It is with immense gratitude and a heart full of emotion that I share my thoughts with you today. More than a decade ago, when New Life Nepal began its journey, I could never have imagined the profound impact it would have—not just on the lives of the children we serve, but on my own life as well.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Full Width Content Sections */}
          <div className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
            <div style={{
              padding: '40px',
              backgroundColor: '#F9FAFB',
              borderRadius: '15px',
              marginBottom: '40px'
            }}>
              <h3 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '700', marginBottom: '25px', textAlign: 'center' }}>
                <i className="fa-solid fa-heart" style={{ color: '#03A84A', marginRight: '12px' }}></i>
                The Greatest Blessing: Being Called "Daddy"
              </h3>
              <div style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.9' }}>
                <p style={{ marginBottom: '20px' }}>
                  There is a magical moment that happens almost every day at New Life Nepal—a moment that fills my eyes with tears of joy and my heart with overwhelming gratitude. It's when one of our children runs to me with open arms and calls out, <strong>"Daddy!"</strong> In that single word, I hear trust, love, hope, and belonging. I hear the voice of a child who has found safety after uncertainty, who has found love after loss, and who has found a home after feeling lost.
                </p>
                <p style={{ marginBottom: '20px' }}>
                  These are not just words to me—they are the purest form of blessing. Many of these children came to us having never known a parent's love. Some lost their parents too early, others were abandoned because of their disabilities, and many faced challenges that seemed insurmountable. Yet here they are, calling me "Daddy," and in doing so, they give me a gift more precious than anything in this world.
                </p>
                <p style={{ marginBottom: '0' }}>
                  I often reflect on who is truly blessed in this relationship. Is it the children who found a home, or is it me, who found purpose, meaning, and unconditional love? The truth is, we bless each other. They have taught me patience, resilience, empathy, and the true definition of courage. Every day, they remind me that love transcends biological bonds and that family is built through care, commitment, and compassion.
                </p>
              </div>
            </div>

            <div style={{
              padding: '40px',
              backgroundColor: '#E8F4FD',
              borderRadius: '15px',
              marginBottom: '40px'
            }}>
              <h3 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '700', marginBottom: '25px', textAlign: 'center' }}>
                <i className="fa-solid fa-road" style={{ color: '#3498db', marginRight: '12px' }}></i>
                The Journey: More Than a Decade of Service
              </h3>
              <div style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.9' }}>
                <p style={{ marginBottom: '20px' }}>
                  When I look back at where we started, I am amazed by how far we have come. Over ten years ago, New Life Nepal was born from a simple but powerful vision: to create a safe, loving home for children who needed it most—particularly those with special needs who are often overlooked and underserved.
                </p>
                <p style={{ marginBottom: '20px' }}>
                  We began with limited resources but unlimited determination. I remember the early days vividly—the sleepless nights, the financial struggles, the moments of doubt. But every time I felt overwhelmed, I would look into the eyes of a child and see hope. That hope kept me going. It still does.
                </p>
                <div className="row g-4" style={{ marginTop: '30px', marginBottom: '30px' }}>
                  <div className="col-md-6">
                    <div style={{ padding: '25px', backgroundColor: 'white', borderRadius: '10px', height: '100%' }}>
                      <h5 style={{ color: '#0C2239', fontSize: '20px', fontWeight: '600', marginBottom: '15px' }}>
                        <i className="fa-solid fa-star" style={{ color: '#03A84A', marginRight: '10px' }}></i>
                        Our Humble Beginnings
                      </h5>
                      <p style={{ marginBottom: '0' }}>
                        We started with just a handful of children and a small team of dedicated caretakers. Every rupee was carefully spent, every meal was planned with care, and every child was given the attention they deserved. It was challenging, but it was also the most fulfilling work I had ever done.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div style={{ padding: '25px', backgroundColor: 'white', borderRadius: '10px', height: '100%' }}>
                      <h5 style={{ color: '#0C2239', fontSize: '20px', fontWeight: '600', marginBottom: '15px' }}>
                        <i className="fa-solid fa-chart-line" style={{ color: '#3498db', marginRight: '10px' }}></i>
                        Growing Together
                      </h5>
                      <p style={{ marginBottom: '0' }}>
                        Today, New Life Nepal has grown beyond what I ever imagined. We serve dozens of children with various needs—from Down syndrome and cerebral palsy to autism, ADHD, and developmental challenges. We have also opened our doors to orphaned children who simply need a loving home.
                      </p>
                    </div>
                  </div>
                </div>
                <p style={{ marginBottom: '0' }}>
                  This growth has been possible because of the incredible support from donors, volunteers, and partners who believed in our mission. To each of you, I extend my deepest gratitude. You have helped us transform lives, one child at a time.
                </p>
              </div>
            </div>

            <div style={{
              padding: '40px',
              backgroundColor: '#FFF5F2',
              borderRadius: '15px',
              marginBottom: '40px'
            }}>
              <h3 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '700', marginBottom: '25px', textAlign: 'center' }}>
                <i className="fa-solid fa-hands-holding-child" style={{ color: '#03A84A', marginRight: '12px' }}></i>
                The Children: Our Greatest Teachers
              </h3>
              <div style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.9' }}>
                <p style={{ marginBottom: '20px' }}>
                  People often commend me for the work I do, but the truth is, the children are the ones who have taught me the most valuable lessons. They have shown me what true strength looks like. Imagine facing daily challenges with mobility, communication, or learning—and yet waking up every morning with a smile, eager to play, learn, and grow. That is the kind of resilience that humbles me.
                </p>
                <p style={{ marginBottom: '20px' }}>
                  I have witnessed children with cerebral palsy take their first independent steps after months of therapy. I have seen children with autism slowly open up and form beautiful bonds with caretakers and friends. I have watched children who came to us unable to speak, laugh, or play, transform into joyful, expressive individuals who light up every room they enter.
                </p>
                <p style={{ marginBottom: '20px' }}>
                  These are not miracles—they are the results of consistent care, unconditional love, and unwavering belief in each child's potential. Every child at New Life Nepal has their own unique story, their own struggles, and their own dreams. Our job is to nurture those dreams and help them become reality.
                </p>
                <p style={{ marginBottom: '0' }}>
                  The orphaned children who call this place home have also changed my perspective on family. Family is not just about blood relations—it's about showing up every day, providing support, and creating a safe space where love can flourish. These children have made me a better person, a more patient listener, and a more compassionate human being.
                </p>
              </div>
            </div>

            <div style={{
              padding: '40px',
              background: 'linear-gradient(135deg, #0C2239 0%, #1a3a5c 100%)',
              borderRadius: '15px',
              marginBottom: '40px',
              color: 'white'
            }}>
              <h3 style={{ color: 'white', fontSize: '28px', fontWeight: '700', marginBottom: '25px', textAlign: 'center' }}>
                <i className="fa-solid fa-shield-heart" style={{ color: '#03A84A', marginRight: '12px' }}></i>
                Our Commitment: Excellence in Care
              </h3>
              <div style={{ color: 'rgba(255, 255, 255, 0.95)', fontSize: '16px', lineHeight: '1.9' }}>
                <p style={{ marginBottom: '20px' }}>
                  At New Life Nepal, we don't just provide basic care—we strive for excellence in everything we do. Each child receives personalized attention tailored to their unique needs. Our team of dedicated caretakers is trained to handle the complexities that come with caring for children with special needs and orphaned children.
                </p>
                <div className="row g-4" style={{ marginTop: '30px', marginBottom: '30px' }}>
                  <div className="col-md-4">
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      <div style={{ width: '80px', height: '80px', backgroundColor: 'rgba(247, 79, 34, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                        <i className="fa-solid fa-graduation-cap" style={{ fontSize: '36px', color: '#03A84A' }}></i>
                      </div>
                      <h5 style={{ color: 'white', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Education & Learning</h5>
                      <p style={{ marginBottom: '0', fontSize: '15px' }}>Every child attends school and receives educational support tailored to their abilities</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      <div style={{ width: '80px', height: '80px', backgroundColor: 'rgba(247, 79, 34, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                        <i className="fa-solid fa-heart-pulse" style={{ fontSize: '36px', color: '#03A84A' }}></i>
                      </div>
                      <h5 style={{ color: 'white', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Healthcare & Therapy</h5>
                      <p style={{ marginBottom: '0', fontSize: '15px' }}>Regular medical checkups, medications, and therapeutic activities to support development</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      <div style={{ width: '80px', height: '80px', backgroundColor: 'rgba(247, 79, 34, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                        <i className="fa-solid fa-house-heart" style={{ fontSize: '36px', color: '#03A84A' }}></i>
                      </div>
                      <h5 style={{ color: 'white', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Home & Family</h5>
                      <p style={{ marginBottom: '0', fontSize: '15px' }}>A warm, loving environment where every child feels safe, valued, and part of a family</p>
                    </div>
                  </div>
                </div>
                <p style={{ marginBottom: '0', textAlign: 'center', fontSize: '17px' }}>
                  We ensure proper nutrition, clean clothing, comfortable shelter, emotional support, and most importantly, an abundance of love. This is not just a care facility—it is a home, and these children are family.
                </p>
              </div>
            </div>

            <div style={{
              padding: '40px',
              backgroundColor: '#F9FAFB',
              borderRadius: '15px',
              marginBottom: '40px'
            }}>
              <h3 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '700', marginBottom: '25px', textAlign: 'center' }}>
                <i className="fa-solid fa-telescope" style={{ color: '#3498db', marginRight: '12px' }}></i>
                Looking Ahead: The Future of New Life Nepal
              </h3>
              <div style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.9' }}>
                <p style={{ marginBottom: '20px' }}>
                  As I reflect on the past ten years, I am filled with pride for what we have accomplished. But I am even more excited about the future. There are still so many children out there who need our help. There are families struggling to care for children with special needs who don't have access to the resources they require. There are orphaned children sleeping on streets, in overcrowded shelters, or in situations where they are not receiving the love and care they deserve.
                </p>
                <p style={{ marginBottom: '20px' }}>
                  My vision for New Life Nepal is to continue expanding our reach. I dream of a day when no child in Nepal has to go without proper care, education, or love—regardless of their abilities or circumstances. I envision better facilities, more trained staff, enhanced therapeutic programs, and partnerships with educational institutions to ensure every child reaches their full potential.
                </p>
                <p style={{ marginBottom: '0' }}>
                  But dreams require support. We cannot do this alone. We need compassionate individuals, organizations, and communities who share our vision and are willing to contribute—whether through financial donations, volunteering their time, or simply spreading awareness about our cause.
                </p>
              </div>
            </div>

            <div style={{
              padding: '50px 40px',
              background: 'linear-gradient(135deg, #03A84A 0%, #01944B 100%)',
              borderRadius: '15px',
              color: 'white',
              textAlign: 'center',
              marginBottom: '40px'
            }}>
              <i className="fa-solid fa-hands-holding-heart" style={{ fontSize: '56px', marginBottom: '25px', display: 'block' }}></i>
              <h3 style={{ color: 'white', fontSize: '32px', fontWeight: '700', marginBottom: '20px' }}>
                Your Support Makes All the Difference
              </h3>
              <p style={{ fontSize: '18px', marginBottom: '15px', color: 'rgba(255, 255, 255, 0.95)', maxWidth: '800px', margin: '0 auto 15px' }}>
                Every contribution—no matter the size—helps us continue our mission of providing love, care, and dignity to children in need.
              </p>
              <p style={{ fontSize: '17px', marginBottom: '35px', color: 'rgba(255, 255, 255, 0.9)', maxWidth: '800px', margin: '0 auto 35px' }}>
                Your donation provides nutritious meals, quality education, medical care, therapeutic activities, safe shelter, and the emotional support that every child deserves. You are not just donating money—you are giving hope, building futures, and changing lives.
              </p>
              <Link 
                to="/contact"
                style={{
                  display: 'inline-block',
                  padding: '18px 50px',
                  backgroundColor: 'white',
                  color: '#03A84A',
                  fontSize: '18px',
                  fontWeight: '600',
                  borderRadius: '50px',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 5px 20px rgba(0, 0, 0, 0.2)'
                }}
              >
                <i className="fa-solid fa-heart" style={{ marginRight: '10px' }}></i>
                Support Our Mission Today
              </Link>
            </div>

            <div style={{
              padding: '40px',
              backgroundColor: 'white',
              borderRadius: '15px',
              border: '2px solid #E5E7EB',
              textAlign: 'center'
            }}>
              <p style={{ fontSize: '17px', color: '#6F7174', lineHeight: '1.9', marginBottom: '25px' }}>
                To all our supporters, volunteers, donors, and partners—thank you from the depths of my heart. You have made it possible for me to hear the sweetest words a person can hear: "Daddy." You have helped create a family for children who desperately needed one. You have given them not just shelter, but a home; not just food, but nourishment; not just care, but love.
              </p>
              <p style={{ fontSize: '18px', color: '#0C2239', fontWeight: '600', marginBottom: '15px' }}>
                Together, we are building a brighter future, one child at a time.
              </p>
              <div style={{ marginTop: '30px' }}>
                <p style={{ fontSize: '18px', color: '#6F7174', marginBottom: '10px' }}>
                  With heartfelt gratitude and endless blessings,
                </p>
                <p style={{ fontSize: '28px', color: '#03A84A', fontWeight: '700', marginBottom: '8px' }}>
                  Rajan Khanal
                </p>
                <p style={{ fontSize: '17px', color: '#6F7174', fontWeight: '500' }}>
                  Chairperson & Founder
                </p>
                <p style={{ fontSize: '16px', color: '#0C2239', marginTop: '5px' }}>
                  New Life Nepal
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Message area end here */}
    </>
  );
};

export default MessageChairperson;
